import moment from 'moment';

const camelToSnake = (obj: any): any => {
  // Return unchanged if not an object or is null
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }

  // Handle arrays specially
  if (Array.isArray(obj)) {
    return obj.map((item) => camelToSnake(item));
  }

  // Handle regular objects
  const newObj: any = {};
  Object.keys(obj).forEach((key) => {
    const newKey = key.replace(/([A-Z])/g, '_$1').toLowerCase();
    const value = obj[key];

    // Recursively convert nested objects or arrays
    newObj[newKey] = camelToSnake(value);
  });

  return newObj;
};

const snakeToCamel = (obj: any): any => {
  if (typeof obj !== 'object' || obj === null) {
    return obj; // return unchanged if obj is not an object or is null
  }

  // if obj is an array, recursively convert each element
  if (Array.isArray(obj)) {
    return obj.map((v: any) => snakeToCamel(v));
  }

  const newObj: any = {};
  Object.keys(obj).forEach((key) => {
    const newKey = key.replace(/_([a-z])/g, (g) => g[1].toUpperCase());
    // if the value is an object, recursively convert it
    if (typeof obj[key] === 'object' && obj[key] !== null) {
      newObj[newKey] = snakeToCamel(obj[key]);
      return;
    }
    newObj[newKey] = obj[key];
  });
  return newObj;
};

function isAllDayTimeRange(start: moment.Moment, end: moment.Moment): boolean {
  if (!start.isValid() || !end.isValid()) return false;

  const durationMinutes = end.diff(start, 'minutes');
  if (durationMinutes === 1440) return true;

  if (durationMinutes === 1439) {
    return start.hour() === 0 && start.minute() === 0
      && end.hour() === 23 && end.minute() === 59;
  }

  if (durationMinutes > 1440) {
    const startsAtMidnight = start.hour() === 0 && start.minute() === 0;
    const endsAtMidnight = end.hour() === 0 && end.minute() === 0
      && durationMinutes % 1440 === 0;
    const endsAtDayEnd = end.hour() === 23 && end.minute() === 59
      && durationMinutes % 1440 === 1439;

    return startsAtMidnight && (endsAtMidnight || endsAtDayEnd);
  }

  return false;
}

export * from './timezone';
export {
  camelToSnake,
  snakeToCamel,
  isAllDayTimeRange,
};
